export function expectArrayPayload<T>(payload: unknown, resourceName: string): T[] {
  if (Array.isArray(payload)) {
    return payload as T[];
  }
  throw new Error(`${resourceName} returned invalid payload`);
}

export function expectPagePayload<T>(
  payload: unknown,
  resourceName: string,
  validator: (value: unknown) => value is T
): T {
  if (validator(payload)) {
    return payload;
  }
  throw new Error(`${resourceName} returned invalid payload`);
}
